import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "count-total" }
const _hoisted_2 = { class: "bar-chart--wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "card-title" }, "Total settled", -1)),
    _createElementVNode("div", _hoisted_1, "$" + _toDisplayString($setup.getTotalSale), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode($setup["Vue3ChartJs"], {
        id: $setup.lineChart.id,
        type: $setup.lineChart.type,
        data: $setup.lineChart.data,
        options: $setup.lineChart.options,
        ref: "chartRef"
      }, null, 8, ["id", "type", "data", "options"])
    ])
  ]))
}